module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_c('div', {
    staticClass: "button-wrapper"
  }, [_c('div', {
    staticClass: "button-circle",
    class: [_vm.isLoading ? 'is-loading' : '']
  }, _vm._l(([, , , ]), function(dot) {
    return _c('div', {
      staticClass: "button-dot"
    })
  })), _c('div', {
    staticClass: "button-label"
  }, [_vm._v(_vm._s(_vm.isLoading ? _vm.$t('load') : _vm.$t('load-more')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-674edaef","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/list/load-more-button.vue
// module id = 490
// module chunks = 0